import { site } from '@panel/commons/helpers';

const env = process.env; // eslint-disable-line

function ecommercePathBuilder(planId, postingId, userType) {
  const currentPortal = site.id;
  let userTypeParam = '';

  const portales = {
    ZPAR: 'zonaprop.com.ar/publica-tu-propiedad',
    WIBR: 'wimoveis.com.br/anuncie-seu-imovel',
    UBPE: 'urbania.pe/publica-tu-aviso',
    IWBR: 'imovelweb.com.br/anuncie-seu-imovel',
    ICBR: 'imoveiscuritiba.com.br/anuncie-seu-imovel',
    DVPE: 'adondevivir.com/publica-tu-propiedad',
    '24MX': 'inmuebles24.com/publica-tu-propiedad',
    PLEC: 'plusvalia.com/publica-tu-propiedad',
    CAPA: 'compreoalquile.com/publica-tu-propiedad',
    VAMX: 'vivanuncios.com.mx/publica-tu-propiedad'
  };

  const locationDomAux =
    env.NODE_ENV !== 'development'
      ? `${window.location.host}/${portales[currentPortal].split('/')[1]}`
      : `desa1.${portales[currentPortal]}`;

  if (currentPortal.includes('BR')) {
    userTypeParam = userType === '1' ? 'particular' : 'profissional';
  } else {
    userTypeParam = userType === '1' ? 'particular' : 'profesional';
  }

  return `https://${locationDomAux}/${userTypeParam}/${planId}/payment?idPosting=${postingId}&from=publisher`;
}

function isPaymentScreen(pathname = '') {
  return pathname.endsWith('pago');
}

function getPaymentSuccessTo(postingId) {
  if (site.isEcuador) {
    return { pathname: '/' };
  }

  return {
    pathname: '/publicador/planes/vistaprevia',
    search: `?postingId=${postingId}`
  };
}

export { ecommercePathBuilder, isPaymentScreen, getPaymentSuccessTo };
